import {
  SET_AVAILABLE_TIME_SUCCESS,
  SET_AVAILABLE_TIME_ERROR,
  GET_CURRENT_AVAILABLE_TIME,
  GET_CURRENT_AVAILABLE_TIME_ERROR,
  GET_AVAILABLE_TIME_OF_TEACHER_SUCCESS,
  GET_CURRENT_AVAILABLE_OF_TEACHER_ERROR,
  CANCEL_BOOKED_LESSON_ERROR,
  CANCEL_BOOKED_LESSON_ERROR_TEACHER,
  BOOK_TIME_SUCCESS,
  BOOK_TIME_ERROR,
  SYNC_ORDER_SUCCESS,
  SYNC_ORDER_ERROR,
  ADD_A_AVAILABLE_DURATION,
  REMOVE_A_AVAILABLE_DURATION,
  FETCH_AVAILABLE_TIME_REQUEST
} from '../actions/types'

const initialState = {
  availableTime: [],
  loading: true,
  currentTeacher: null,
  error: null,
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case FETCH_AVAILABLE_TIME_REQUEST:
      return {
        ...state,
        loading: false,
        error: null
      }
    case SET_AVAILABLE_TIME_SUCCESS:
    case GET_AVAILABLE_TIME_OF_TEACHER_SUCCESS:
      return {
        ...state,
        loading: false,
        availableTime: payload.availableTime,
      }
    case BOOK_TIME_SUCCESS:
      return {
        ...state,
        loading: false,
        availableTime: payload.newTeacherAvailableTime.availableTime,
      }
    case ADD_A_AVAILABLE_DURATION:
      return {
        ...state,
        availableTime: [...state.availableTime, payload]
      }
    case REMOVE_A_AVAILABLE_DURATION:
      return {
        ...state,
        availableTime: state.availableTime.filter(time => time.id !== payload)
      }
    case SYNC_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        availableTime: payload.teacherAvailableTime,
      }
    case GET_CURRENT_AVAILABLE_TIME:
      return {
        ...state,
        loading: false,
        currentTeacher: payload.user,
        availableTime: payload.availableTime,
      }
    case SET_AVAILABLE_TIME_ERROR:
    case GET_CURRENT_AVAILABLE_TIME_ERROR:
    case GET_CURRENT_AVAILABLE_OF_TEACHER_ERROR:
      return {
        ...state,
        loading: false,
        currentTeacher: null,
        error: payload,
      }
    case CANCEL_BOOKED_LESSON_ERROR_TEACHER:
    case CANCEL_BOOKED_LESSON_ERROR:
    case BOOK_TIME_ERROR:
    case SYNC_ORDER_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      }
    default:
      return state
  }
}
